module.exports = __webpack_public_path__ + "img/ungrouped_results.806c324f.svg";